import { Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";


@Injectable({
  providedIn: 'root'
})
export class FormHelperService {
  constructor() {
  }

  isControlValid(valForm: FormGroup, controlName: string): boolean {
    const control = valForm.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }

  isControlInvalid(valForm: FormGroup, controlName: string): boolean {
    const control = valForm.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }
  isSelectInvalid(valForm: FormGroup, controlName: string): boolean {
    const control = valForm.controls[controlName];
    return control.value=="";
  }
  controlHasError(valForm: FormGroup, validation: string, controlName: string) {
    const control = valForm.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }

  isControlTouched(valForm: FormGroup, controlName: string): boolean {
    const control = valForm.controls[controlName];
    return control.dirty || control.touched;
  }
}
